import { chakra } from "@chakra-ui/react";
import { FormLabelSharedProps } from "./FormLabel.props";
import OptionalIndicator from "../OptionalIndicator/OptionalIndicator.web";

// Use a styled label element instead of Field.Label to avoid requiring Field.Root context
// This allows FormLabel to be used standalone or within FormControl
const StyledLabel = chakra("label", {
  base: {
    display: "block",
    textAlign: "start",
    fontSize: "md",
    fontWeight: "medium",
    marginEnd: "3",
    marginBottom: "1",
    color: "fg",
  },
});

const FormLabel = ({
  children,
  isOptional,
  ...props
}: FormLabelSharedProps) => {
  return (
    <StyledLabel {...props}>
      {children}
      {isOptional ? <OptionalIndicator /> : null}
    </StyledLabel>
  );
};

export default FormLabel;
